import * as React from 'react';
import * as cx from 'classnames';
import SuperCritical from 'lib/supercritical';
import { noPropagation } from 'lib/eventWrappers';

import { ApprovedCharge } from 'data/models/ApprovedCharge';
import { BillItem } from 'data/models/BillItem';

import { ExportGroupList, ExportGroup, Columns, PRICE_PRECISION } from './exportgrouplist';

import { GridDivHeaderCells, GridDivRowCells } from 'portcall/gridcomponents/view';

export const ExportGroupListView = SuperCritical(({ model: m } : { model : ExportGroupList }) =>
    <div className="exportgrouplist">
        <ExportGroupListHeader model={m} />
        {m.ExportGroups().map(g =>
            <ExportGroupView model={m} group={g} key={g.UniqueKey()} />
        )}
    </div>
);

let ExportGroupListHeader = SuperCritical(({ model: m } : { model : ExportGroupList }) =>
    <div className={cx('export-group-list-header-row')}>
        {GridDivHeaderCells(Columns, m.RowSorter, 'export-group-list-cell')}
        <div className="export-group-list-cell group-selector">
            {/* TH 05/08/2017 -- Need &nbsp; to fill height b/c this isn't a true table header */}
            &nbsp;
        </div>
    </div>
);

let ExportGroupView = SuperCritical(({ model: m, group: g } : { model : ExportGroupList, group : ExportGroup }) =>
    <div className={cx('export-group', { expanded: g.Expanded() })}>
        <ExportGroupSummaryView model={m} group={g} />
        <ExportGroupChargesView group={g} />
    </div>
);

let ExportGroupSummaryView = SuperCritical(({ model: m, group: g } : { model : ExportGroupList, group : ExportGroup }) =>
    <div className="export-group-summary"
        onClick={() => g.Expanded(!g.Expanded())}>
        {GridDivRowCells(Columns, g, 'export-group-list-cell')}
        <div className="export-group-list-cell group-selector">
            {m.ShowGroupSelectors() &&
                <input type="checkbox"
                    checked={g.SelectedForExport()}
                    onClick={noPropagation(() => {})}
                    onChange={e => g.SelectedForExport(e.currentTarget.checked)} />
            }
        </div>
    </div>
);

let ExportGroupChargesView = SuperCritical(({ group: g } : { group : ExportGroup }) =>
    <table className="export-group-charges">
        <thead className="pc-text-billing-label">
            <tr>
                <th className="item-code">Item Code</th>
                <th className="description">Description</th>
                <th className="quantity">Qty.</th>
                <th className="rate">Rate</th>
                <th className="total">Total</th>
            </tr>
        </thead>
        <tbody>
            {g.Charges().map(c =>
                <GroupChargeItemView charge={c} key={c.Id()} />
            )}
        </tbody>
    </table>
);

let GroupChargeItemView = SuperCritical(({ charge: c } : { charge : ApprovedCharge | BillItem }) =>
    <tr>
        {/* TH 05/05/2017 -- Unlike for the Pilotage Charges flip, I figure this page is specific
            to QuickBooks, so we'll use the QB-specific item code. So in theory this code might
            not match what we show on the Pilotage Charges flip.
            Something to figure out more if we add another possible export target */}
        <td className="item-code">{c.StandardItem() && c.StandardItem()!.QBTracking.Name()}</td>
        <td className="description">{c.Description()}</td>
        <td className="quantity">{c.NumberOfUnits()}</td>
        <td className="rate">{c.UnitPrice.toString({ places: PRICE_PRECISION })}</td>
        <td className="total">{c.Total.toString({ places: PRICE_PRECISION })}</td>
    </tr>
);


// WEBPACK FOOTER //
// ./apps/portcall/quickbooksexports/exportgrouplistview.tsx